/* 自动生成入口 './build/bin/build-entry.js' */
import kyHello from '../packages/hello/index.js'
import kybtn from '../packages/kbtn/index.js'
import kyLogin from '../packages/login/index';
import kyVLogin from '../packages/vlogin/index';
// import routes from '../examples/router/routes'
import kyRegister from '../packages/register/index';
import kyClaimPwd from '../packages/claim/index';
import kyUpdatePwd from '../packages/Resetpassword/index';
import kyDialogdrawerdefect from '../packages/dialogdrawerdefect/index';
import kyPagination from '../packages/pagination/index';
import kyTree from '../packages/tree/index';
import kyModelView from '../packages/formTableView/index';
import kyPreviewDialog from '../packages/previewDialog/index'
import ky404 from '../packages/404/index'

const components = [
  kyHello,
  kybtn,
  kyLogin,
  kyVLogin,
  kyRegister,
  kyClaimPwd,
  kyUpdatePwd,
  kyDialogdrawerdefect,
  kyPagination,
  kyTree,
  kyModelView,
  kyPreviewDialog,
  ky404
]

const install = function(app, opts = {}) {
  // 判断是否安装
  if (install.installed) return

  components.forEach(component => {
    app.component(component.name, component);
  })

}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

//可按需引入
export {
  kyHello,
  kybtn,
  kyLogin,
  kyVLogin,
  kyRegister,
  kyClaimPwd,
  kyUpdatePwd,
  kyDialogdrawerdefect,
  kyPagination,
  kyTree,
  kyModelView,
  kyPreviewDialog,
  ky404
}
//可全部引入
export default {
  version: '0.0.3',
  // 全部注册
  install,
  // 按需引用
  kyHello,
  kybtn,
  kyLogin,
  kyVLogin,
  kyRegister,
  kyClaimPwd,
  kyUpdatePwd,
  kyDialogdrawerdefect,
  kyPagination,
  kyTree,
  kyModelView,
  kyPreviewDialog,
  ky404
}
// 组件命名规范 k 或 ky 开头，如：KyLogin



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = null
// module chunks = 